import {caretRightSvg as Icon__small__caretRightSvg} from '../Icon__small/Icon__small--caretRight.js'

export var caretRight = {
  name: 'caretRight',
  category: 'icon',
  colorable: true,
  svg: Icon__small__caretRightSvg,
};
